import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'redaction'
import actions from 'redux/actions'
import { mixpanel, snowplow, constants } from 'common/helpers'
import { FormattedHTMLMessage } from 'sb-react-intl'

import Modal from 'components/modal/Modal/Modal'
import Button from 'components/buttons/Button/Button'

import messages from './messages'
import s from './TryTwoThreeFragrancesModal.scss'

import MaleImage from './images/male.svg'
import FemaleImage from './images/female.svg'


class TryTwoThreeFragrancesModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    image: PropTypes.string,
    closedPopups: PropTypes.object,
  }

  static defaultProps = {
    name: constants.modals.TryTwoThreeFragrances,
    closedPopups: {},
  }

  close = () => {
    const { name, onClose } = this.props

    actions.models.ui.setClosedPopup(constants.modals.TryTwoThreeFragrances)
    actions.models.modals.close(name)

    if (onClose && typeof onClose === 'function') {
      onClose()
    }
  }

  componentDidMount() {
    mixpanel.track(constants.analyticsEvents.twoThreeScents)
  }

  confirm = () => {
    const placement = '2-3 scents popup'

    snowplow.track(constants.snowplowEvents.upgradeSubscriptionClick, {
      placement,
    }, false)

    actions.models.subscription.handleUpgradeClick({ placement })
    this.close()
  }

  render() {
    const { name, image } = this.props

    return (
      <Modal
        name={name}
        title={messages.title}
        onClose={this.close}
      >
        <img src={image} alt="" />
        <FormattedHTMLMessage tag="div" {...messages.text} />
        <Button
          className={s.confirm}
          lg
          brand
          fullWidth
          title={messages.confirmTitle}
          onClick={this.confirm}
        />
        <Button
          className={s.cancel}
          lg
          emptyGray
          fullWidth
          title={messages.cancelTitle}
          onClick={this.close}
        />
      </Modal>
    )
  }
}


export default connect({
  image: (state) => state.models.me.gender === 'male' ? MaleImage : FemaleImage,
  closedPopups: 'models.ui.closedPopups',
})(TryTwoThreeFragrancesModal)
